module.exports = __webpack_public_path__ + "img/679f50a.jpg";